
export default {
  name: "UserIndex"
}
